import React, { useState } from 'react';
import { Redux, Slices } from 'spwa-ui-library';
import { generateProductRoute } from 'spwa-ui-library/esm/utils/path';
import ClassNames from 'classnames';
import { useIntl } from 'react-intl';
import Skeleton from 'react-loading-skeleton';
import { useLocation, useNavigate } from '@reach/router';

// LOCAL IMPORTS
import ProductTileDescription from './ProductTileDescription';
import ProductName from './ProductName';
import CustomizedBox from './CustomizedBox';
import FavouriteBar from './FavouriteBar';
import AddtoCart from './AddToCart';
import ProductTilePrice from './ProductTilePrice';
import ProductTileImage from './ProductTileImage';

import overlayImg1 from './images/overlayImg1.png';
import overlayImg2 from './images/overlayImg2.png';

import { generateCustomization, getStoreMappingPH } from 'spwa-ui-library/esm/utils/helper';
import css from './index.module.scss';
import ConfirmRelocateToCart from './ConfirmRelocateToCart';
import {
  addToCartGA,
  trackingAddedToCartGA,
  addToWishlistGA,
  removeFromCartGA,
  removeItemGA,
} from 'spwa-ui-library/esm/utils/helperGA';
import ProductVariations from './ProductVariations';
import ChangeOrderMode from './ChangeOrderMode';
import ChangeOrderModeDialog from './ChangeOrderModeDialog';
import OpenCartDialog from './OpenCartDialog';
import classNames from 'classnames';
const { useSelector, useDispatch } = Redux;
const { selectDesktop } = Slices.appSlice;
const { addItem, removeItem } = Slices.favouriteSlice;
const { cartItems, reduceItemCat, increaseItemCat, increaseItem, reduceItem } = Slices.cartSlice;
const { updateCustomizeItem, updateProductPayload } = Slices.tempCartSlice;
const { selectCurrentCountry } = Slices.profileSlice;
const { selectDefaultAddress } = Slices.addressSlice;
const { selectCountryValidations, getClusterId } = Slices.configSlice;
const { selectProductEntities, getProductInfo } = Slices.productSlice;

export default function ProductTile({
  oldLocation,
  currentStepperId,
  setCurrentStepperId,
  cartIndex,
  currentStep,
  classOverRide,
  isCustomized,
  mainProductId,
  isBundleItem,
  stepId,
  showFavorite = true,
  cartItem,
  priceTo,
  onAddCart,
  productObj,
  category = {},
  isPreviouslyOrdered,
  position,
  returnURL,
  setShowBundleGroupDialog,
  setShowCustomizeProductDialog,
  totalItems,
  productOrderIndex,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const locationSearch = new URLSearchParams(location.search);

  const isDesktop = useSelector(selectDesktop);
  const cart = useSelector(cartItems);
  const intl = useIntl();
  const temp = useSelector((state) => state.tempCart);
  const tagsState = useSelector((state) => state.tags);
  const fav = useSelector((state) => state.favourite);
  const bogoProducts = useSelector((state) => state.product.bogoProdList);
  const productsMap = useSelector(selectProductEntities);
  const address = useSelector(selectDefaultAddress);
  const clusterId = useSelector(getClusterId);
  const categoryInfo = useSelector((state) => state.category);
  const country = useSelector(selectCurrentCountry).toString().toLowerCase();
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const [showRelocateBox, setShowRelocateBox] = React.useState(false);
  const [orderModeProductId, setOrderModeProductId] = useState(0);
  const [show, setShow] = useState(false);
  const [showCartDialog, setShowCartDialog] = useState(false);
  const categoryProduct = (productObj?.categories?.length && productObj?.categories[0]) || 0;
  let buildCat = false;
  if (countryValidations.makeYourOwnPizza?.categoryId >= 1) {
    buildCat = countryValidations.makeYourOwnPizza?.categoryId == categoryProduct ? true : false;
  }

  let productRoute = generateProductRoute({
    product: productObj,
    category,
    locale: intl.locale.toLowerCase(),
  });

  if (
    (productObj?.bundleTypeId === 'bundle' || productObj?.bundleTypeId === 'bundle_group') &&
    productObj?.typeId != 'simple'
  ) {
    productRoute = `${productRoute}/bundle`;
  }

  if (window.location.pathname.includes('bundle')) {
    productRoute = `${productRoute}?main_product=${mainProductId}&step=${currentStepperId}`;
    if (locationSearch.has('option')) {
      productRoute = `${productRoute}&option=${locationSearch.get('option')}`;
    }
    if (locationSearch.has('cartId')) {
      productRoute = `${productRoute}&cartId=${locationSearch.get('cartId')}`;
    }
  }

  const discountPercentage = productObj && productObj.discountPercentage;
  const currency = countryValidations?.currency;
  let matches = [];
  let tempQty = 0;
  const days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
  const completeDays = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
  ];

  const checkIfInsideTiming = (startTime, endTime) => {
    let date = new Date(
      new Date().toLocaleString('en-US', { timeZone: countryValidations?.timezone, hour12: true })
    );
    let start = startTime.split(':');
    let end = endTime.split(':');

    const startDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      parseInt(start[0]),
      parseInt(start[1]),
      0
    );

    const endDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      parseInt(end[0]),
      parseInt(end[1]),
      0
    );

    return startDate.getTime() <= date.getTime() && date.getTime() <= endDate.getTime();
  };

  const checkIfFutureTiming = (startTime) => {
    let date = new Date(
      new Date().toLocaleString('en-US', { timeZone: countryValidations?.timezone, hour12: true })
    );
    let start = startTime.split(':');

    const startDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      parseInt(start[0]),
      parseInt(start[1]),
      0
    );

    return startDate.getTime() >= date.getTime();
  };

  const formatCurrentTime = (currentTime) => {
    let date = new Date(
      new Date().toLocaleString('en-US', { timeZone: countryValidations?.timezone, hour12: true })
    );
    let current = currentTime.split(':');

    const currentDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      parseInt(current[0]),
      parseInt(current[1]),
      0
    );

    let hours = currentDate.getHours() > 12 ? currentDate.getHours() - 12 : currentDate.getHours();
    let am_pm = currentDate.getHours() >= 12 ? 'PM' : 'AM';
    hours = hours < 10 ? '0' + hours : hours;
    let minutes =
      currentDate.getMinutes() < 10 ? '0' + currentDate.getMinutes() : currentDate.getMinutes();

    return hours + ':' + minutes + ' ' + am_pm;
  };

  let isItemAvailable = true;
  let nextAvailableDay = '';

  const defaultTimings = { from: '00:00', to: '00:00' };
  const currentDayOfWeek =
    days[
      new Date(
        new Date().toLocaleString('en-US', { timeZone: countryValidations?.timezone, hour12: true })
      ).getDay()
    ];

  if (productObj?.availableSlot) {
    if (Object.values(productObj?.availableSlot || {}).length === 0) {
      isItemAvailable = false;
    } else {
      const dayTimings = productObj?.availableSlot?.[currentDayOfWeek] || defaultTimings;
      let dealFallsInTiming = false;

      for (let timing of Array.isArray(dayTimings)
        ? dayTimings
        : Object.keys(dayTimings || {}).length > 0
        ? [dayTimings]
        : []) {
        if (checkIfInsideTiming(timing?.from, timing?.to)) {
          dealFallsInTiming = true;
          break;
        }
      }
      if (!dealFallsInTiming) {
        isItemAvailable = false;
      }
    }
  }

  if (!isItemAvailable) {
    let searchStartsFrom = new Date(
      new Date().toLocaleString('en-US', { timeZone: countryValidations?.timezone, hour12: true })
    ).getDay();
    for (let i = searchStartsFrom + 1; i < 7; i++) {
      if (!nextAvailableDay && Object.values(productObj?.availableSlot?.[days[i]] || {}).length) {
        nextAvailableDay = completeDays[i];
        break;
      }
    }

    if (!nextAvailableDay) {
      for (let i = 0; i < searchStartsFrom; i++) {
        if (!nextAvailableDay && Object.values(productObj?.availableSlot?.[days[i]] || {}).length) {
          nextAvailableDay = completeDays[i];
          break;
        }
      }
    }
  }

  let nextTime;
  if (nextAvailableDay) {
    // check if today slot is available in future
    for (let timing of productObj?.availableSlot?.[currentDayOfWeek] || []) {
      if (checkIfFutureTiming(timing?.from)) {
        nextTime = formatCurrentTime(timing?.from);
        break;
      }
    }
  }

  // CART PRICE
  let priceCart =
    productObj?.price >= 0
      ? productObj?.price
      : productObj?.specialPrice || productObj?.originalPrice || 0;
  const cartExist = cart ? Object.entries(cart).length : -1;
  if (cartExist !== -1) {
    priceCart = 0;
    matches = cart.filter((item) => {
      const cond =
        item.id == (isBundleItem ? mainProductId : productObj?.id) ||
        (!item?.id && item.catId == (isBundleItem ? mainProductId : productObj?.id)) ||
        (productObj?.typeId == 'bundle_group' &&
          item.parentId == (isBundleItem ? mainProductId : productObj?.id)) ||
        item?.additionalInfo?.bundleGroupId == productObj?.id;

      if (cond) {
        if (isBundleItem) {
          let itemBundle = item?.['bundle'];
          if (productsMap[mainProductId]?.typeId == 'simple') {
            itemBundle = item?.['items'] || item?.['bundle'];
          }
          tempQty =
            tempQty +
            (itemBundle?.[currentStepperId]?.[productObj?.id]
              ? itemBundle?.[currentStepperId]?.[productObj?.id]?.qty || 1
              : 0);
        } else {
          tempQty = tempQty + (item?.qty || 0);
        }
        return true;
      }
      return false;
    });
    if (matches.length < 2) {
      priceCart = 0;
    }
  }
  tempQty = cartItem ? 0 : tempQty;

  const tempCartExists = temp.customize.items.find((item) => item?.id == productObj?.id);
  const cartProdExists = cart.find((item) => item?.id == productObj?.id);
  if (
    (tempCartExists && tempCartExists['variants']) ||
    (cartProdExists && cartProdExists['variants'])
  ) {
    let variants;
    if (Object.values(tempCartExists?.['variants'] || {}).length > 0) {
      variants = Object.values(tempCartExists?.['variants']);
    } else {
      variants = Object.values(cartProdExists?.['variants'] || {});
    }
    let selectedItemInfo = productObj?.items?.find((itemInfo) => {
      let item;
      if (!itemInfo?.id) {
        item = productsMap[itemInfo];
      } else {
        item = itemInfo;
      }

      let isSameVariant = true;

      for (let i = 0; i < variants.length; i++) {
        if (item?.[`sel${i + 1}Value`] != variants[i]) {
          isSameVariant = false;
          break;
        }
      }
      return isSameVariant;
    });
    let selectedItem = selectedItemInfo?.id ? selectedItemInfo : productsMap[selectedItemInfo];

    priceCart =
      selectedItem?.price || selectedItem?.specialPrice || selectedItem?.originalPrice || priceCart;
  }

  const isFavourite = fav.data.items.findIndex((id) => id == productObj?.id);
  //  TODO NEED TO MOVE CODE TO HELPER FUNCTION
  const handleFavouritetoggle = (product) => (e) => {
    e.preventDefault();

    if (isFavourite !== -1) {
      dispatch(removeItem(product.id));
    } else {
      dispatch(addItem(product.id));
      const selectCategory = categoryInfo.entities[product.categories[0]];
      addToWishlistGA(currency, product, selectCategory?.name);
    }
    return false;
  };

  const customizeItem = isCustomized !== -1 ? temp.data.items[isCustomized] : [];
  // CART ITEM CUSTOMIZATION
  if (cartItem) {
    dispatch(updateCustomizeItem(customizeItem));
  }

  const handleIncrement = (productInstance) => (e) => {
    if (e) e.preventDefault();
    if (isBundleItem) {
      const originalProductCustomization = temp.data.items.find(
        (product) => product.id == mainProductId
      );
      let productCustomization;
      if (originalProductCustomization) {
        productCustomization = JSON.parse(JSON.stringify(originalProductCustomization));
        // Further processing with productCustomization...
      } else {
        console.log('Product customization not found or undefined.');
      }

      const currentStepInfo = productsMap[mainProductId]?.steps?.find(
        (step) => step?.id == currentStepperId
      );

      let customizationItem = productCustomization?.['bundle'];
      if (productsMap[mainProductId]?.typeId == 'simple') {
        customizationItem = productCustomization?.['items'] || productCustomization?.['bundle'];
      }

      const currentStepProductsCount =
        Object.values(customizationItem?.[currentStepperId] || {})?.reduce((totalQty, product) => {
          return totalQty + (product?.qty || 0);
        }, 0) || 0;

      if (currentStepProductsCount >= (currentStepInfo?.maximum || Number.MAX_SAFE_INTEGER)) {
        // TODO: Show a message here
        return;
      }

      // just add the product into the tempCart.data
      if (!customizationItem?.[currentStepperId]) {
        customizationItem[currentStepperId] = {};
      }
      if (!customizationItem[currentStepperId]?.[productObj.id]) {
        customizationItem[currentStepperId][productObj.id] = {};
      }
      if (customizationItem[currentStepperId][productObj.id]?.notAdded) {
        delete customizationItem[currentStepperId][productObj.id]['notAdded'];
      }

      // add qty, isDefault and default variants
      customizationItem[currentStepperId][productObj.id]['qty'] = 1;

      if (!customizationItem?.[currentStepperId]?.[productObj.id]?.['variants']) {
        customizationItem[currentStepperId][productObj.id]['variants'] = {};
        customizationItem[currentStepperId][productObj.id]['isDefault'] = true;
      }

      // add base price -
      let stepInfo;
      let bgSteps;
      if (
        productsMap[mainProductId]?.isBOGO ||
        productsMap[mainProductId]?.bundleTypeId == 'bundle_group'
      ) {
        const paramsStepId = parseInt(locationSearch.get('step'));
        const optionId = parseInt(locationSearch.get('option'));

        bgSteps = productsMap[mainProductId]?.items?.find((item) => {
          let itemInfo;
          if (!item?.id) {
            itemInfo = productsMap[item];
          } else {
            itemInfo = item;
          }

          return itemInfo?.id == optionId || itemInfo?.sel1Value == optionId;
        });

        if (!bgSteps?.id) {
          bgSteps = productsMap[bgSteps];
        }

        if (!Array.isArray(bgSteps?.steps) || !bgSteps?.steps?.length) {
          bgSteps = productsMap[bgSteps?.id];
        }

        stepInfo = bgSteps?.steps?.find((step) => step?.id == (paramsStepId || currentStepperId));
      } else {
        stepInfo = productsMap[mainProductId]?.steps?.find((step) => step?.id == currentStepperId);
      }

      const productInfo = stepInfo?.options?.find((option) => option?.id == productObj?.id);

      if (stepInfo?.options?.length === 1 && stepInfo?.minimum > 1) {
        customizationItem[currentStepperId][productObj.id]['qty'] = stepInfo?.minimum;
      }

      let previousMatches = {};
      let allProducts = [];
      for (let step of Object.values(productCustomization?.['bundle'] || {})) {
        for (let [pId, pObj] of Object.entries(step)) {
          allProducts = [...allProducts, { ...pObj, id: pId }];
        }
      }
      let matches = allProducts?.filter((item) => item.id == productObj.id);
      let actualMatches = [];
      for (let match of matches) {
        let doesVariationExist = true;
        for (let [variantId, selectedVariant] of Object.entries(match?.variants || {})) {
          // check if this combo exists in productObj or not
          let currentVariation = productObj?.variants?.find((v) => v.id == variantId);
          let currentSelectedVariation = currentVariation?.options?.find(
            (cv) => cv.id == selectedVariant
          );

          if (!currentSelectedVariation) {
            doesVariationExist = false;
          }
        }

        if (doesVariationExist) {
          actualMatches.push(match);
        }
      }
      matches = actualMatches;

      if (matches.length) {
        previousMatches = matches[0];
      }

      if (
        Object.keys(
          productCustomization?.bundle?.[currentStepperId]?.[productObj.id]?.variants || {}
        ).length == 0
      ) {
        customizationItem[currentStepperId][productObj.id]['variants'] =
          previousMatches?.variants || {};
      }

      let variationArray = [-1, -1, -1];
      let currentProductVariation;

      let productKeys =
        Object.keys(
          productCustomization?.bundle?.[currentStepperId]?.[productObj.id]?.variants || {}
        ).length > 0
          ? productCustomization?.bundle?.[currentStepperId]?.[productObj.id]?.variants
          : previousMatches?.variants;

      if (!productKeys) {
        productKeys = {};
      }

      if (Object.keys(productKeys || {}).length > 0) {
        Object.values(productKeys || {}).forEach((variant, index) => {
          variationArray[index] = variant;
        });
      } else {
        (productInfo?.variants || []).forEach((variant, index) => {
          const selectedOption = variant?.options?.find((option) => option?.isSelected == 1);

          if (selectedOption) {
            variationArray[index] = selectedOption?.id;
            if (!customizationItem?.[currentStepperId]?.[productObj.id]?.['variants']) {
              customizationItem[currentStepperId][productObj.id]['variants'] = {};
            }
            customizationItem[currentStepperId][productObj.id]['variants'][variant?.id] =
              selectedOption?.id;
          }
        });
      }

      if (Object.keys(productKeys).length == 0) {
        delete customizationItem[currentStepperId][productObj.id]['variants'];
        delete customizationItem[currentStepperId][productObj.id]['isDefault'];
      }

      if ((productInfo?.items?.length || 0) < 2 || productInfo?.typeId == 'simple') {
        currentProductVariation = productInfo?.items?.[0] || productInfo;
      } else {
        currentProductVariation = productInfo?.items?.find((item) => {
          let isVariantSame = true;
          variationArray.forEach((variant, index) => {
            if (item[`sel${index + 1}Value`] != variant) {
              isVariantSame = false;
            }
          });
          return isVariantSame;
        });
      }

      let cartData;
      if (locationSearch.has('cartId')) {
        cartData = cart[locationSearch.get('cartId')];
      }

      const currentPrice =
        currentProductVariation?.price >= 0
          ? currentProductVariation?.price
          : currentProductVariation?.specialPrice || currentProductVariation?.originalPrice || 0;

      productCustomization['price'] = productsMap[mainProductId]?.isBOGO
        ? Math.max(productCustomization['price'] || 0, currentPrice)
        : (productCustomization['price'] || 0) + currentPrice * (cartData?.qty || 1);

      if (productsMap[mainProductId]?.isBOGO) {
        customizationItem[currentStepperId][productObj.id]['price'] = currentPrice;
      }

      const addedProducts = Object.values(customizationItem || {}).length;
      const qtyInfo = addedProducts > 0 ? { addedProducts: addedProducts } : {};

      let bogoPrice = 0;

      if (productsMap[mainProductId]?.isBOGO) {
        const items = [];

        for (let step of Object.values(productCustomization?.bundle || {})) {
          const itemId = Object.keys(step)[0];
          const itemCustomization = Object.values(step)[0];

          const optionId = parseInt(locationSearch.get('option'));
          let productObj = productsMap[productCustomization]?.items
            ?.find((item) => item?.id == optionId)
            ?.steps?.[0]?.options?.find((option) => option?.id == itemId);

          if (!productObj) {
            productObj = bogoProducts[optionId]?.find((option) => option?.id == itemId);
          }

          let itemInfo;
          let selectedItemIndex = -1;

          if ((productObj?.items?.length || 0) < 2 || productObj?.typeId == 'simple') {
            selectedItemIndex = 0;
          } else {
            let variationArray = [-1, -1, -1];

            if (Object.values(itemCustomization?.variants || {}).length > 0) {
              Object.values(itemCustomization?.variants || {}).forEach((variant, index) => {
                variationArray[index] = variant;
              });
            } else {
              Object.values(productObj?.variants || {}).forEach((variant, index) => {
                const selectedOption = variant?.options?.find((option) => option?.isSelected == 1);
                if (selectedOption) {
                  variationArray[index] = selectedOption?.id;
                }
              });
            }

            productObj.items.forEach((item, i) => {
              let areVariationsSame = true;
              variationArray.forEach((value, index) => {
                if (item[`sel${index + 1}Value`] != value) {
                  areVariationsSame = false;
                }
              });

              if (areVariationsSame) {
                selectedItemIndex = i;
              }
            });
          }

          itemInfo = productObj?.items?.[selectedItemIndex];
          if (!itemInfo?.steps?.options) {
            itemInfo =
              productsMap[productObj?.id]?.items?.find((item) => item?.id == itemInfo?.id) ||
              productObj?.items[selectedItemIndex] ||
              itemInfo;
          }
          if (!itemInfo?.id) {
            itemInfo = productsMap[itemInfo];
          }

          let basePrice = 0;
          basePrice +=
            itemInfo?.price >= 0
              ? itemInfo?.price
              : itemInfo?.specialPrice || itemInfo?.originalPrice || 0;

          let extraPrice = 0;

          for (let step of itemInfo?.steps || []) {
            for (let option of step?.options || []) {
              if (option?.subOptions) {
                extraPrice +=
                  option?.subOptions[itemCustomization?.items?.[step.id]?.[option.id]?.['qty'] - 1]
                    ?.price || 0;
              } else {
                if (itemCustomization?.items?.[step.id]?.[option.id]?.['qty']) {
                  extraPrice +=
                    (option?.price || 0) *
                    Number(itemCustomization?.items?.[step.id]?.[option.id]?.['qty'] || 0);
                }
              }
            }
          }

          items.push({
            id: productObj?.id,
            name: productObj?.name || productObj?.title,
            basePrice: basePrice || 0,
            extraPrice: extraPrice || 0,
          });
        }

        if ((items[0]?.basePrice || 0) == (items[1]?.basePrice || 0)) {
          items.sort(
            (item1, item2) =>
              item2.basePrice + item2.extraPrice - (item1.basePrice + item1.extraPrice)
          );
        } else {
          items.sort((item1, item2) => item2.basePrice - item1.basePrice);
        }

        bogoPrice = items[0].basePrice || 0;
        for (let item of items) {
          bogoPrice += item.extraPrice || 0;
        }
      }

      dispatch(
        updateProductPayload({
          data: {
            ...productCustomization,
            price: productsMap[mainProductId]?.isBOGO
              ? bogoPrice * (cartData?.qty || 1)
              : productCustomization.price,
            additionalInfo: { ...(productCustomization?.additionalInfo || {}), ...qtyInfo },
          },
        })
      );
      let currentlyAddedItems = Object.keys(customizationItem[currentStepperId] || {}).length;
      let step = productsMap[mainProductId]?.steps?.find((step) => step.id == stepId);
      let minimumRequiredItems = Math.min(step?.minimum || 1, step?.options?.length || 1) || 0;

      let availableSteps =
        productsMap[mainProductId]?.steps?.filter((step) => !step?.isHidden) || [];
      let nextStepIndex = availableSteps?.findIndex((s) => s.id == currentStepperId);
      let nextStepId =
        availableSteps[nextStepIndex + 1]?.id || availableSteps[availableSteps.length - 1]?.id;

      if (currentlyAddedItems >= minimumRequiredItems && setCurrentStepperId && nextStepId) {
        console.log(`3 setting - `, nextStepId);
        setCurrentStepperId((prev) => parseInt(nextStepId));
      }
    } else {
      dispatch(
        getProductInfo({
          id: productInstance?.id,
          cluster: clusterId,
          service: address?.addressSubType || 'DELIVERY',
          categoryId: productInstance['categories']?.[0],
          Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
        })
      ).then((resp) => {
        let { items, ...product } = JSON.parse(JSON.stringify(productInstance));

        const checkinCart = cart.filter((val) => {
          return val.id === product.id;
        });

        const customizedProduct =
          temp.data.items.find((prod) => prod.id == product.id) ||
          temp.customize.items.find((prod) => prod.id == product.id);
        if (product?.bundleTypeId == 'configurable') {
          // update variants
          const variationArray = [-1, -1, -1];
          let newProductVariation;
          if (customizedProduct?.variants) {
            product['variants'] = product.variants.map((variant, index) => {
              const selectedOption = customizedProduct?.variants[variant.id];
              variationArray[index] = selectedOption;
              variant['options'] = variant?.options.map((option) => {
                option['isSelected'] = option['id'] == selectedOption ? 1 : 0;
                return option;
              });
              return variant;
            });
            newProductVariation = product?.items?.find((item) => {
              let isVariantSame = true;
              variationArray.forEach((variant, index) => {
                if (item[`sel${index + 1}Value`] != variant) {
                  isVariantSame = false;
                }
              });
              return isVariantSame;
            });
            product['currentPrice'] =
              newProductVariation?.specialPrice || newProductVariation?.originalPrice || 0;
          }
        }
        const selectedSize = product.selectedItem;
        if (checkinCart.length) {
          const checkItm = [...checkinCart].filter((val) => val.selectedItem === selectedSize);

          if (product.bundleTypeId == 'simple' || checkItm.length) {
            addToCartGA(product, currency, category.name, 'ProductListingPage');
            trackingAddedToCartGA(product, currency, category.name, address);

            if (product?.isHomePageItem) {
              if (!cartIndex) cartIndex = cart.map((c) => c.id).lastIndexOf(product?.id);
              dispatch(increaseItem({ id: cartIndex }));
            } else {
              return dispatch(
                increaseItemCat({
                  productType: product.bundleTypeId,
                  updatedOn: new Date().getTime(),
                  mainProductId: product.id,
                  data: { ...product, category: category.id },
                })
              );
            }
          } else {
            return onAddCart(product);
          }
        } else {
          const myPromise = new Promise((resolve, reject) => {
            onAddCart(product);
          });
          myPromise
            .then((res) => {
              if (res === 'succeeded') {
                setShow((prev) => false);
              }
            })
            .catch((err) => {
              console.log('err', err);
            });
        }
      });
    }
  };

  const handleDecrement = (productID, productInstance) => (e) => {
    e.preventDefault();
    if (productObj?.bundleTypeId == 'bundle_group') {
      // get item count
      let items = cart.filter(
        (item) =>
          item?.additionalInfo?.bundleGroupId == productID ||
          item?.catId == productID ||
          item?.parentId == productID
      );
      if (items?.length > 1) {
        setShowCartDialog(true);
      } else if (items?.length == 1) {
        let itemIndex = cart.findIndex(
          (item) =>
            item?.additionalInfo?.bundleGroupId == productID ||
            item?.catId == productID ||
            item?.parentId == productID
        );
        dispatch(reduceItem({ index: itemIndex }));
      }

      return;
    }

    const { items, ...product } = productInstance;
    const productCustomization = temp.customize.items.find((item) => item.id == product.id);
    // TODO: Remove "Customized" box of deleted item
    if (cartItem) {
      return dispatch(reduceItem({ index: cartIndex }));
    }
    if (matches.length > 1) {
      setShowCartDialog(true);
    } else {
      let variants = product['variants'] ? JSON.parse(JSON.stringify(product['variants'])) : null;
      if (variants && productCustomization) {
        for (let i = 0; i < variants?.length; i++) {
          for (let j = 0; j < variants[i]?.options.length; j++) {
            if (variants[i]?.options[j]?.id == productCustomization?.variants[variants[i]?.id]) {
              variants[i].options[j]['isSelected'] = 1;
            } else {
              variants[i].options[j]['isSelected'] = 0;
            }
          }
        }
      }

      if (productObj?.isHomePageItem) {
        if (!cartIndex) cartIndex = cart.map((c) => c.id).lastIndexOf(product?.id);
        dispatch(reduceItem({ index: cartIndex }));
      } else {
        dispatch(
          reduceItemCat({
            productType: product.bundleTypeId,
            updatedOn: new Date().getTime(),
            mainProductId: product.id,
            data: { ...product, variants: variants, category: category.id },
          })
        );
      }
    }

    removeFromCartGA(product, countryValidations?.currency, category, 'ProductListingPage');
    removeItemGA(product, countryValidations?.currency, category);
  };
  // CURRENCY ICON
  const currencyIcon = currency ? currency : 'AED';

  let productTags =
    tagsState.status === 'succeeded'
      ? Object.values(tagsState?.data || {})
          .filter((tag) => productObj?.tags?.includes(tag.tagId))
          .sort((tag1, tag2) => tag1.position - tag2.position)
      : [];

  productTags = productTags.map((productTag) =>
    countryValidations?.['tags_assets']?.find((tagAsset) => tagAsset.tagId == productTag.tagId)
  );
  const categoryIdFromPath = parseInt(location.pathname.split('/').pop());
  const hideFavIconForBYOP =
    categoryIdFromPath === +categoryProduct &&
    ['Build Your Own', 'جهز البيتزا الخاصة بك'].includes(productObj?.metaTitle);
  const favouriteBar =
    showFavorite && !isBundleItem ? (
      <FavouriteBar
        isFavourite={isFavourite}
        onToggle={handleFavouritetoggle(productObj)}
        tags={productTags}
      />
    ) : (
      ''
    );

  if (!productObj) {
    console.log(`returning null`);
    return null;
  }

  const { assets } = productObj;
  const menuItem = productObj ? productsMap[productObj?.action?.id] : {};
  // TODO: UNCOMMENT TO SHOW CUSTOMIZED CARD
  const getCustomize = () => {
    const inCusto = temp?.data?.items?.findIndex(({ id }) => id === +productObj?.id);
    let other = [];
    menuItem &&
      menuItem.items &&
      menuItem.items.length &&
      menuItem.items.forEach((inner) => {
        other.push(productsMap[inner]);
      });

    const ItemCustomize = { ...menuItem, items: other };
    const getCustomizeVal = generateCustomization(temp?.data?.items[inCusto], ItemCustomize);

    return (
      <CustomizedBox
        route={productRoute}
        customizeDescription={getCustomizeVal}
        productObj={productObj}
      />
    );
  };

  if (Object.keys(productObj).length === 0) {
    return <Skeleton count={10} className={css.Skeleton} height={56} />;
  }

  let hideCustomize =
    productObj.bundleTypeId === 'bundle' ||
    productObj.bundleTypeId === 'bundle_group' ||
    productObj.bundleTypeId === 'configurable'
      ? false
      : true;

  if (isBundleItem && productObj?.variants) {
    hideCustomize = false;
  }

  if (productObj?.isHomePageItem) {
    hideCustomize = false;
  }

  if (productObj.bundleTypeId == 'simple') hideCustomize = true;

  const addressType = getStoreMappingPH(address?.addressSubType || 'DELIVERY');
  const availableOrderModes = Object.keys(productObj?.services || {})
    ?.map((orderMode) => (productObj?.services[orderMode] ? orderMode : null))
    .filter((orderMode) => orderMode != null);

  const handleOrderModePopup = (id) => {
    setOrderModeProductId((prev) => id);
  };

  const handleOnClick = (newOrderMode) => {
    let modalName = '';
    switch (newOrderMode) {
      case 'carhop': {
        modalName = 'carhop';
        break;
      }
      case 'delevery': {
        modalName = 'addaddress';
        break;
      }
      case 'take_away': {
        modalName = 'store';
        break;
      }
      case 'dine_in': {
        modalName = 'dinein';
        break;
      }
      case 'drivethru': {
        modalName = 'drivethru';
        break;
      }
      default: {
        modalName = 'addaddress';
      }
    }
    handleOrderModePopup(0);
    if (isDesktop) {
      navigate(`${location.pathname}?modal=${modalName}`);
    } else {
      navigate(`/${intl.locale}/${modalName}`);
    }
  };
  const classValu = productObj.typeId;

  const shouldShowChangeOrderModePopup =
    !productObj?.services?.[addressType] && availableOrderModes.length > 0;
  const getProductOrder = () => {
    if (!isItemAvailable) {
      return totalItems + 20;
    }
    if (isPreviouslyOrdered && isFavourite > -1) {
      return productOrderIndex?.indexOf(productObj.id);
    }
    if (isPreviouslyOrdered) {
      return productOrderIndex?.indexOf(productObj.id) + totalItems;
    } else if (isFavourite > -1) {
      return (3 + totalItems) * 2;
    } else {
      return (4 + totalItems) * 3;
    }
  };

  return (
    <>
      <div
        style={{ order: getProductOrder() }}
        key={`itemList${productObj?.name_en}`}
        className={ClassNames(css.root, {
          [classOverRide]: classOverRide,
          [css.disabledTile]: !isItemAvailable,
          [css.ownPizza]: buildCat,
          [css.searchTileCss]: returnURL === `/${intl.locale}/search` && isDesktop,
        })}
      >
        <div className={css.productInfoContainer}>
          {!isItemAvailable && (
            <div className={css.disabledDealInfo}>
              <div className={css.overlayImg}>
                <div className={css.overlayImg1}>
                  <img src={overlayImg1} alt="small" />
                  <span className={classNames({ [css.currentDayTime]: nextTime })}>
                    {nextTime
                      ? intl.formatMessage({ id: 'available_from' })
                      : intl.formatMessage({ id: 'deal_live_again_on' })}
                  </span>
                </div>
                <div className={css.overlayImg2}>
                  <img src={overlayImg2} alt="large" />
                  {nextTime ? (
                    <span className={css.mediumText}>{nextTime}</span>
                  ) : (
                    <span
                      className={classNames({
                        [css.largeText]:
                          intl.formatMessage({ id: nextAvailableDay?.toLowerCase() || 'tuesday' })
                            .length < 7,
                        [css.smallText]:
                          intl.formatMessage({ id: nextAvailableDay?.toLowerCase() || 'tuesday' })
                            .length > 7,
                      })}
                    >
                      {intl.formatMessage({ id: nextAvailableDay?.toLowerCase() || 'tuesday' })}
                    </span>
                  )}
                </div>
              </div>
            </div>
          )}
          {shouldShowChangeOrderModePopup && (
            <div className={css.overLay} onClick={() => handleOrderModePopup(productObj.id)}></div>
          )}
          <ProductName productName={productObj?.name_en || productObj?.name || productObj?.title} />
          {productObj?.customized ? (
            getCustomize()
          ) : (
            <>
              <ProductTileDescription
                productDescription={productObj && productObj?.description}
                descriptionLength={isDesktop ? 120 : 90}
              />
            </>
          )}
          {shouldShowChangeOrderModePopup && (
            <ChangeOrderMode
              availableModes={availableOrderModes}
              productId={productObj?.id}
              handleOrderModePopup={handleOrderModePopup}
            />
          )}
          {hideFavIconForBYOP || productObj?.isBOGO ? '' : favouriteBar}
        </div>
        
        <div className={css.productCtaContainer}>
          <ProductTileImage
            imageSrc={`${assets && assets[0].src}`}
            productName={productObj?.name_en}
            productRoute={productRoute}
            productObj={productObj}
            oldLocation={oldLocation}
            returnURL={returnURL}
            mainProductId={mainProductId}
            isPreviouslyOrdered={isPreviouslyOrdered}
            name={productObj?.name || productObj?.title}
            buildCat={buildCat}
          >
            {!buildCat && (
              <ProductTilePrice
                name={productObj?.name || productObj?.title}
                oldLocation={oldLocation}
                productRoute={productRoute}
                discountPercentage={discountPercentage}
                strikeOutPrice={productObj?.strikeOutPrice || 0}
                price={
                  productObj?.isHomePageItem
                    ? priceTo
                    : (
                      priceCart
                      ? priceCart
                      : productObj?.specialPrice || productObj?.originalPrice                      
                    )
                }
                keyVal={productObj?.name + productObj?.id}
                currency={currencyIcon}
                hideCustomize={hideCustomize}
                returnURL={returnURL}
                productId={productObj?.id}
                productObj={productObj}
                categoryId={category?.id}
                mainProductId={mainProductId}
                isBundleItem={isBundleItem}
                currentStepperId={currentStepperId}
                setShowCustomizeProductDialog={setShowCustomizeProductDialog}
                setShowBundleGroupDialog={setShowBundleGroupDialog}
              />
            )}
          </ProductTileImage>
          <div
            className={ClassNames(css.selectVariations, css['varient_' + classValu], {
              [css.paddedBlock]: shouldShowChangeOrderModePopup,
              [css.atRowEnd]: productObj?.isHomePageItem,
            })}
          >
            {!productObj?.isHomePageItem && (
              <ProductVariations
                productRoute={productRoute}
                hideButton={cartItem}
                inSide={productObj?.inSide || 0}
                productObj={productObj}
                currency={currency}
                categoryObj={categoryInfo.entities[category?.id]}
                position={position}
                mainProductId={mainProductId}
                isBundleItem={isBundleItem}
                stepId={stepId}
              />
            )}
            {!shouldShowChangeOrderModePopup && !buildCat && (
              <AddtoCart
                buildCat={buildCat}
                productObj={productObj}
                isBundleItem={isBundleItem}
                mainProductId={mainProductId}
                currency={currencyIcon}
                qty={tempQty}
                currentStepId={currentStepperId}
                stepId={stepId}
                onIncrement={handleIncrement(productObj)}
                onDecrement={handleDecrement(productObj?.id, productObj)}
                load={show}
                setShowCartDialog={setShowCartDialog}
                returnURL={returnURL}
                setCurrentStepperId={setCurrentStepperId}
                setShowCustomizeProductDialog={setShowCustomizeProductDialog}
                setShowBundleGroupDialog={setShowBundleGroupDialog}
                productRoute={
                  productObj?.bundleTypeId == 'bundle' || productObj?.bundleTypeId == 'bundle_group'
                    ? productRoute
                    : null
                }
              />
            )}
            {buildCat && tempQty ? (
              <AddtoCart
                buildCat={buildCat}
                productObj={productObj}
                isBundleItem={isBundleItem}
                mainProductId={mainProductId}
                currency={currencyIcon}
                qty={tempQty}
                currentStepId={currentStepperId}
                stepId={stepId}
                onIncrement={handleIncrement(productObj)}
                onDecrement={handleDecrement(productObj?.id, productObj)}
                load={show}
                setShowCartDialog={setShowCartDialog}
                returnURL={returnURL}
                setCurrentStepperId={setCurrentStepperId}
                setShowCustomizeProductDialog={setShowCustomizeProductDialog}
                setShowBundleGroupDialog={setShowBundleGroupDialog}
                productRoute={
                  productObj?.bundleTypeId == 'bundle' || productObj?.bundleTypeId == 'bundle_group'
                    ? productRoute
                    : null
                }
              />
            ) : (
              ''
            )}
            {buildCat && !tempQty && (
              <ProductTilePrice
                buildCat={buildCat}
                name={productObj?.name || productObj?.title}
                oldLocation={oldLocation}
                productRoute={productRoute}
                discountPercentage={discountPercentage}
                strikeOutPrice={productObj?.strikeOutPrice || 0}
                price={
                  productObj?.isHomePageItem
                    ? priceTo
                    : (
                      priceCart
                      ? priceCart
                      : productObj?.specialPrice || productObj?.originalPrice                      
                    )
                }
                keyVal={productObj?.name + productObj?.id}
                currency={currencyIcon}
                hideCustomize={hideCustomize}
                returnURL={returnURL}
                productId={productObj?.id}
                productObj={productObj}
                categoryId={category?.id}
                mainProductId={mainProductId}
                isBundleItem={isBundleItem}
                currentStepperId={currentStepperId}
                setShowCustomizeProductDialog={setShowCustomizeProductDialog}
                setShowBundleGroupDialog={setShowBundleGroupDialog}
              />
            )}
          </div>
        </div>
        <ConfirmRelocateToCart
          isOpen={showRelocateBox}
          onClose={() => {
            setShowRelocateBox(false);
          }}
        />
      </div>
      {orderModeProductId > 0 && (
        <ChangeOrderModeDialog
          productId={orderModeProductId}
          availableModes={availableOrderModes}
          handleOrderModePopup={handleOrderModePopup}
          handleOnClick={handleOnClick}
        />
      )}
      {showCartDialog && <OpenCartDialog setShowCartDialog={setShowCartDialog} />}
    </>
  );
}
